var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nibnut-aspect-ratio-box nibnut-ratio-gallery image-placeholder"},[_c('div',[_c('open-icon',{attrs:{"glyph":"camera","size":_vm.size}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }